// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangeEmailAddressCard_actionButtonStyle__mNzzg","form":"ChangeEmailAddressCard_form__cYD3-","gridContainer":"ChangeEmailAddressCard_gridContainer__xcPQ3"};